import { render, staticRenderFns } from "./fc-coins.vue?vue&type=template&id=5b190450&scoped=true"
import script from "./fc-coins.vue?vue&type=script&lang=js"
export * from "./fc-coins.vue?vue&type=script&lang=js"
import style0 from "./fc-coins.vue?vue&type=style&index=0&id=5b190450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b190450",
  null
  
)

export default component.exports